import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import StepperGuide from "./StepperGuide";
import {useState} from "react";

interface CameraFrontGuideModalPropsType {
    openModal: boolean
}

export default function CameraFrontGuideModal(props: CameraFrontGuideModalPropsType) {
    const { openModal } = props
    const [modalState, setModalState] = useState<any>(openModal)
    const callback = (modalState: boolean | undefined) => {
        setModalState(modalState)
    }
    return (
        <div>
            <Dialog
                open={modalState}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ sx: { width: "370px", maxWidth: '100%' , height: "auto" } }}
            >
                <DialogContent style={{ textAlign: 'center', overflow: "hidden" }}>
                    <DialogContentText style={{ margin: '0 auto', display: 'table' }} id="alert-dialog-description">
                        <span style={{ fontFamily: 'iranSans', fontSize: '15px', color: '#367e9e' }}>راهنمای تشخیص چهره</span>
                    </DialogContentText>
                    <DialogContentText style={{ margin: '0 auto', display: 'table' }} id="alert-dialog-description">
                        <StepperGuide onClick={callback} />
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div>
    );
}
